import { DelayedSpinner } from "@digipost/dds-spinner-react";
import { useEffect, useState } from "react";

import ErrorPage from "../../ErrorPage";
import { oAuthTokenRedirect } from "../../infrastructure/redux/app/app-actions";
import Translated from "../../infrastructure/Translated";
import styles from "./CompleteOAuth.module.css";

export const CompleteOAuth: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const oAuthToken = urlParams.get("token");

  const [showError, setShowError] = useState(false);

  const doRedirect = async () => {
    if (oAuthToken !== null) {
      window.location.href = await oAuthTokenRedirect(oAuthToken);
    }
  };

  useEffect(() => {
    doRedirect();
  }, [oAuthToken]);

  useEffect(() => {
    const timeoutId = setTimeout(() => setShowError(true), 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  if (showError) {
    return (
      <ErrorPage>
        <Translated textKey="complete_oauth.error" />
      </ErrorPage>
    );
  } else {
    return (
      <div className={styles.spinnerContainer}>
        <DelayedSpinner size="large" />
      </div>
    );
  }
};
